import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/uptime/config/uptime.config.query.gql"
import type {
  UptimeConfigQuery,
  UptimeConfigQueryVariables,
} from "@/v2-backoffice-client/uptime/config/__types__/uptime.config.query"

type Options = QueryHookOptions<UptimeConfigQuery, UptimeConfigQueryVariables>

// useUptimeConfigQuery powers admin surfaces that need the full
// editorial status configuration: platform / category / provider
// catalogues and the per-target overrides keyed by (Source,
// Identifier). The payload is small and changes rarely so we leave
// it cached forever in Apollo and let mutations refetch with
// `awaitRefetchQueries: true` to keep the UI snappy.
export function useUptimeConfigQuery(options?: Options) {
  return useQuery<UptimeConfigQuery, UptimeConfigQueryVariables>(query, options)
}

// UPTIME_CONFIG_REFETCH_QUERIES is the list of refetch handles
// every mutation that edits status config should pass to Apollo's
// `refetchQueries` so the cached config stays in sync.
export const UPTIME_CONFIG_REFETCH_QUERIES = ["UptimeConfigQuery"] as const
